export default "__VITE_ASSET__DfWcq8cj__"